import { pump_registry } from "./pump_registry";
import { generate_pump_vibration_block } from "./generate_pump_vibration_block";
import { formatDateTime, random, round2 } from "../helpers/helpers";

export const generate_pump_latest_dashboard_demo = () => {
    let online = 0;
    let offline = 0;

    const list_of_pump = pump_registry.map((pump) => {
        const is_online = true; // 🔥 ALL PUMPS ONLINE

        if (is_online) online++;
        else offline++;

        return {
            meter_id: pump.meter_id,
            meter_name: pump.meter_name,
            orientation: pump.orientation,

            status: "Online",
            pump_status: "On",
            pump_current_status: "On",

            pump_status_updated_on: formatDateTime(
                new Date(Date.now() - random(1, 3) * 24 * 60 * 60 * 1000)
            ),
            dtime: formatDateTime(new Date()),

            suction_pressure: round2(random(1.4, 2.9)),
            discharge_pressure: round2(random(3.8, 6.9)),
            efficiency: round2(random(68, 85)),
            hydraulic_power: round2(random(14, 28)),

            water_flow: {
                flow_rate: round2(random(240, 460)),
                last_sync_time: formatDateTime(new Date()),
            },

            energy_meter: {
                avg_current: round2(random(38, 92)),
                total_active_power: round2(random(200, 480)),
                last_sync_time: formatDateTime(new Date()),
            },

            bearing_vibration: generate_pump_vibration_block(),
            de_vibration: generate_pump_vibration_block(),
            nde_vibration: generate_pump_vibration_block(),
        };
    });

    return {
        list_of_pump,
        online,
        offline, // always 0
        total: list_of_pump.length,
    };
};